<template>
  <div v-loading.fullscreen="loading" class="login-wrap"
       element-loading-text="正在获取登录信息">
    <el-form
      label-position="left" :model="ruleForm"
      :rules="rules" ref="ruleForm" label-width="0px"
      class="login-container">
      <h3 class="title">重置密码</h3>
      <el-form-item prop="username">
        <el-input type="password" v-model="ruleForm.username" auto-complete="off" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="请再次输入密码">
        </el-input>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click="handleSubmit('ruleForm')" :loading="logining">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'login',
  data () {
    return {
      loading: false,
      // 定义loading默认为false
      loginType: 'account',
      logingMsg: '正在跳转登录页面,请稍后......',
      authURL: '正在跳转登录页面,请稍后......',
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        username: '',
        password: ''
      },
      // rules前端验证
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  watch: {},
  // 创建完毕状态(里面是操作)
  created () {
  },
  mounted () {
    this.getuserpwd()
  },
  // 里面的函数只有调用才会执行
  methods: {
    ...mapActions(['handleLogin']),
    // 获取info列表
    handleSubmit (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$router.push({
            name: 'login'
          })
        } else {
          this.logining = false
          return false
        }
      })
    },
    getuserpwd () {
      if (this.commonUtils.localStorageGet('user')) {
        this.ruleForm = this.commonUtils.localStorageGet('user')
        this.rememberpwd = true
      }
    }
  }
}
</script>

<style scoped>
  .login-wrap {
    box-sizing: border-box;
    width: 100%;
    height: 640px;
    padding-top: 100px;
    background-image: url('../../assets/img/login_bg.jpg');
    /* background-color: #112346; */
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 100%;
  }

  .login-container {
    border-radius: 10px;
    margin: 0px auto;
    width: 300px;
    padding: 30px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    text-align: left;
    box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  }

  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }
</style>
